<template>
  <div class="news-list flex">
    <div v-for="(news, i) in news" :key="i" class="item">
      <a :href="news.url">
        <img :src="news.image" alt="" class="thumbnail" />
      </a>

      <div class="content">
        <p class="date">{{ news.date }}</p>
        <p class="description">
          {{ news.title }}
        </p>
      </div>

        <a :href="news.url" class="arrow-link">
            Read more

            <img src="/images/icons/right-main.svg" alt="" />
        </a>
    </div>
    <div class="pagination">
      <img class="arrow" src="/images/icons/paginate-left.svg" alt="" />

      <div
        v-for="(i, j) in 4"
        :key="j"
        class="numbers"
        :class="{ active: j === 0 }"
      >
        {{ i }}
      </div>

      <div class="see-more">
        <span>...</span>
      </div>
      <img class="arrow" src="/images/icons/paginate-right.svg" alt="" />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    news: {
      type: Array,
      default: () => [
        {
          date: "1 February 2021",
          content: "At vero eos censes tantas res gessisse",
          image: "/images/news-thumb-1.jpg",
        },
        {
          date: "28 January 2021",
          content: "Epicurus in culpa qui haec subtilius velint tradere et",
          image: "/images/news-thumb-2.jpg",
        },
        {
          date: "22 January 2021",
          content: "Probabo inquit sic",
          image: "/images/news-thumb-3.jpg",
        },
        {
          date: "17 January 2021",
          content: "Torquem detraxit hosti et quidem",
          image: "/images/news-thumb-4.jpg",
        },
        {
          date: "1 February 2021",
          content: "At vero eos censes tantas res gessisse",
          image: "/images/news-thumb-1.jpg",
        },
        {
          date: "28 January 2021",
          content: "Epicurus in culpa qui haec subtilius velint tradere et",
          image: "/images/news-thumb-2.jpg",
        },
        {
          date: "22 January 2021",
          content: "Probabo inquit sic",
          image: "/images/news-thumb-3.jpg",
        },
        {
          date: "17 January 2021",
          content: "Torquem detraxit hosti et quidem",
          image: "/images/news-thumb-4.jpg",
        },
        {
          date: "1 February 2021",
          content: "At vero eos censes tantas res gessisse",
          image: "/images/news-thumb-1.jpg",
        },
        {
          date: "28 January 2021",
          content: "Epicurus in culpa qui haec subtilius velint tradere et",
          image: "/images/news-thumb-2.jpg",
        },
        {
          date: "22 January 2021",
          content: "Probabo inquit sic",
          image: "/images/news-thumb-3.jpg",
        },
        {
          date: "17 January 2021",
          content: "Torquem detraxit hosti et quidem",
          image: "/images/news-thumb-4.jpg",
        },
      ],
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// resources/assets/frontend/js/components/ImmigrationNews.vue